<template>
  <v-carousel hide-controls height="300">
    <v-carousel-item v-for="(item,i) in items" :key="i">
      <v-card flat light>
        <!-- <v-img :src="require('@/assets/' + item.image)" ></v-img> -->
        <v-card-title primary-title>
          <v-flex text-xs-center>
            <div class="subheading font-weight-bold mb-0">{{item.title}}</div>
            <span class="grey--text">{{item.date}}</span>
            <br>
            <!-- {{item.desc}} -->
            <span v-html="item.desc"></span>
          </v-flex>
        </v-card-title>
      </v-card>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: "RecentNews",
  data: function() {
    return {
      items: [
        {
          // image: "IIT-M.jpg",
          title: "Paper Accepted",
          date: "28th March 2020",
          desc:
            "Paper titled - <a href=\"/Orion_PaPoC.pdf\">Orion: Time Estimated Causally Consistent Key-Value Store</a> by Diptanshu Kakwani and Rupesh Nasre accepted at <a href=\"https://papoc-workshop.github.io/2020/\">PaPoC 2020</a>"
        },
        {
          // image: "IIT-M.jpg",
          title: "Joined IIT Madras",
          date: "10th July 2018",
          desc:
            "Joined as MS research scholar. Looking forward to working with Prof Rupesh Nasre."
        },
      ]
    };
  }
};
</script>